import { DatePipe } from '@angular/common';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatTable, MatTableDataSource } from '@angular/material';
import { MatButton } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DTOCustomerInfo } from '../../../../@core/models/DTOCustomerInfo';
import { DTOShipment } from '../../../../@core/models/DTOShipment';
import { DTOShipmentAdvancedSearch } from '../../../../@core/models/DTOShipmentAdvancedSearch';
import { ApiProvider } from '../../../../@core/providers/api.provider';
import { AuthenticationService } from '../../../../@core/services/authentication.service';
import { ShipmentService } from '../../../../@core/services/shipment.service';
import { CrmClientLookupDialogComponent } from '../dialogs/crm-client-lookup-dialog/crm-client-lookup-dialog.component';
import { CryptoService } from '../../../../@core/services/encrypt.service';
import { query } from '@angular/animations';

@Component({
  selector: 'crm-search',
  templateUrl: './crm-search.component.html',
  styleUrls: ['./crm-search.component.scss']
})
export class CrmSearchComponent implements OnInit {
  @ViewChild('searchResultsTable', { static: false })
  searchResultsTable: MatTable<any>;
  @ViewChild('searchButton', { static: false })
  private searchButton: MatButton;
  displayedColumns: string[] = [
    'ShipmentId',
    'ExpeditionDate',
    'BillingAccount',
    'Destination.AccountName',
    'Sender.AccountName',
    'Destination.Address1',
    'Destination.City',
    'Destination.PostalCode',
    'ReferenceNumber',
    'Delivered',
    'Pickup'
  ];
  searchDatasource = new MatTableDataSource<DTOShipment>(null);

  waybill: number;
  client: string;
  parcel: number;
  dateStart: Date;
  customerId: number;
  dateEnd: Date;
  reference: string;
  expDate: string;
  account: string;
  consignee: string;
  address: string;
  city: string;
  postalCode: string;
  userId: string;
  lang: string;
  key: string;
  encryptedKey: string;
  page: number;
  dtoShipmentAdvancedSearch: DTOShipmentAdvancedSearch;
  size: number;
  isLoading: boolean = false;

  searchResults: DTOShipment[] = [];

  constructor(
    private _shipmentService: ShipmentService,
    public _translateService: TranslateService,
    public _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private apiProvider: ApiProvider,
    public datePipe: DatePipe,
    private readonly cryptoService: CryptoService
  ) {}

  async ngOnInit() {

    const querystringParams = new URLSearchParams(window.location.search);
    
    this.userId = querystringParams.get('userId');
    this.encryptedKey = querystringParams.get('key');

    console.log(this.userId);
    console.log(this.encryptedKey);
    
    const decryptedKey = await this.cryptoService.decryptBase64(this.encryptedKey, "let encrypt = this.encryptService.encrypt(chaine);")
    this.key = decryptedKey;

    this.lang = querystringParams.get('UserLanguage');

    this.page = 0;
    this.size = 0;
    if (this.lang === '1033') {
      this._translateService.use('en');
    } else if ((this.lang = '1036')) {
      this._translateService.use('fr');
    }

    if (this._authenticationService.currentUserValue === null) {
      this.apiProvider.GetCRMUser(this.userId, this.key).subscribe((res) => {
        if (res) {
          let user = {
            UserID: this.userId,
            UserName: res
          };
          localStorage.setItem('currentUser', JSON.stringify(user));
          this._authenticationService.setUser(user);
        }
      });
    }

    let searchData: DTOShipmentAdvancedSearch = JSON.parse(
      localStorage.getItem('search-data')
    );

    if (searchData !== null) {
      this.waybill = searchData.ShipmentId;
      this.parcel = searchData.ParcelId;
      this.dateStart =  searchData.DateStart ? new Date(searchData.DateStart) : null;
      this.dateEnd = searchData.DateEnd ? new Date(searchData.DateEnd) : null;
      this.reference = searchData.Reference;
      this.expDate = searchData.ExpDate;
      this.account = searchData.ConsigneeAccountId;
      this.consignee = searchData.ConsigneeName;
      this.address = searchData.ConsigneeAddress;
      this.city = searchData.ConsigneeCity;
      this.postalCode = searchData.ConsigneePostalCode;
      this.customerId = searchData.CustomerId;

    } else {
      this.dateEnd = new Date();
      this.dateStart = new Date();
      this.dateStart.setDate(this.dateStart.getDate() - 30);
    }

    this.search();

  }

  EnterSubmit(event) {
    if (event.keyCode === 13) {
      this.search();
    }
  }

  search() {
    this.isLoading = true;
    this.dtoShipmentAdvancedSearch = {
      ShipmentId: this.waybill,
      ParcelId: this.parcel,
      DateStart: this.dateStart ? this.dateStart.toDateString() : null,
      DateEnd: this.dateEnd ? this.dateEnd.toDateString() : null,
      Reference: this.reference,
      ExpDate: this.expDate,
      ConsigneeAccountId: this.account,
      ConsigneeName: this.consignee,
      ConsigneeAddress: this.address,
      ConsigneeCity: this.city,
      ConsigneePostalCode: this.postalCode,
      CustomerId: this.customerId,
      Page: this.page,
      Size: 100
    };

    localStorage.setItem(
      'search-data',
      JSON.stringify(this.dtoShipmentAdvancedSearch)
    );
    
    this._shipmentService
      .GetListShipments(this.dtoShipmentAdvancedSearch, this.userId, this.key)
      .subscribe(
        (results: any) => {
          this.isLoading = false;
          this.searchDatasource = new MatTableDataSource<DTOShipment>(results);
          this.size = results.length;
          localStorage.setItem('search-results', JSON.stringify(results));
        },
        (error) => {
          this.isLoading = false;
          this.searchDatasource = new MatTableDataSource<DTOShipment>(null);
          this.size = 0;
          localStorage.removeItem('search-results');
        }
      );
  }

  clientLookup(): void {
    this.searchButton._elementRef.nativeElement.focus();
    const dialogRef = this.dialog.open(CrmClientLookupDialogComponent, {
      width: '800px',
      height: '500px',
      position: { top: '100px' },
      data: {
        userId: this.userId,
        key: this.key
      }
    });
    dialogRef.afterClosed().subscribe((res: DTOCustomerInfo) => {
      this.searchButton._elementRef.nativeElement.focus();
      if (res !== null) {
        this.customerId = res.CustomerId;
      }
    });
  }

  nextPage() {
    this.dtoShipmentAdvancedSearch.Page =
      this.dtoShipmentAdvancedSearch.Page + 1;

    this._shipmentService
      .GetListShipments(this.dtoShipmentAdvancedSearch, this.userId, this.key)
      .subscribe((results: any) => {
        this.searchDatasource.data = this.searchDatasource.data.concat(results);
        this.searchResultsTable.renderRows();
        this.size = results.length;
      });
  }

  clear() {
    localStorage.removeItem('search-data');
    this.waybill = null;
    this.parcel = null;
    this.dateStart = null;
    this.dateEnd = null;
    this.reference = null;
    this.expDate = null;
    this.account = null;
    this.consignee = null;
    this.address = null;
    this.city = null;
    this.postalCode = null;
    this.customerId = null;

    this.dateEnd = new Date();
    
    this.dateStart = new Date();
    this.dateStart.setDate(this.dateStart.getDate() - 30);

    this.searchDatasource = new MatTableDataSource<DTOShipment>(null);
    this.size = 0;
    localStorage.removeItem('search-results');

  }
}
